import { EitherOrSelection } from 'components/eitherOrSelection/EitherOrSelection';
import React from 'react';
import AppImage from '../../assets/ibanera/Img_Register_01.png';
import SMSImage from '../../assets/ibanera/Img_Register_02.png';
import Button from '../../components/button/Button';
import { AuthType, SelectAuthTypeProps } from './models';

export const SelectAuthType: React.FC<SelectAuthTypeProps> = ({
    translations,
    onComplete,
    authType,
    setAuthType,
}) => {
    const handleSelection = (authType: AuthType) => () => {
        setAuthType(authType);
    };

    return (
        <>
            {translations && (
                <>
                    <div className="RegisterFormWidth">
                        <h1>Add an extra layer of security</h1>
                        <p>Secure your auth by adding two step verification</p>
                    </div>
                    <div className="SelectAccountType">
                        <EitherOrSelection
                            title="Authenticator App"
                            selected={authType === AuthType.APP}
                            onClick={handleSelection(AuthType.APP)}
                            image={AppImage}
                            value={AuthType.APP}
                            recommended
                        />
                        <EitherOrSelection
                            title="SMS"
                            selected={authType === AuthType.SMS}
                            onClick={handleSelection(AuthType.SMS)}
                            image={SMSImage}
                            value={AuthType.SMS}
                        />
                    </div>
                    <div className="RegisterFormWidth BtnContainer">
                        <Button
                            priority="primary"
                            variety="full"
                            className="RegisterFormButton"
                            onClick={onComplete}
                        >
                            {translations.continue_button}
                        </Button>
                    </div>
                </>
            )}
        </>
    );
};
